import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Grid,
    Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { competitionScheduleResultDate } from "../../services/Competition";
import CustomSnackbar from "../../CustomSnackbar";

const DeclarationDialog = ({ open, setOpenDialog, competitionId, setResultAnnouncedDate }) => {
    const [value, setValue] = useState(dayjs());
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");
    const [errors, setErrors] = useState({});

    const formatDate = (date) => date.format("YYYY-MM-DD HH:mm:00");

    // formate date like 10 Jan 2023, 10:00 AM
    const formatDateLike = (date) => date.format("DD MMM YYYY, hh:mm A");

    const handleDeclare = () => {
        if (!competitionId) return;
        // API Call
        const data = {
            result_declaration_date: formatDate(value),
        };
        console.log("Data to sent", data);

        competitionScheduleResultDate(competitionId, data)
            .then((res) => {
                console.log("Competition result date scheduled:", res);
                setResultAnnouncedDate(res.data.result_declaration_date);
                setMessage(res.message || "Winner announcement scheduled successfully!");
                setSeverity("success");
                setOpenDialog(false);
            })
            .catch((err) => {
                console.error("Competition result date scheduled failed:", err);
                setErrors(err.errors || {});
                setMessage(err.message || "Failed to schedule. Please try again.");
                setSeverity("error");
            });
    };


    const handleClose = () => {
        setOpenDialog(false);
        setErrors({});
    };

    return (
        <React.Fragment>
            <CustomSnackbar
                open={!!message}
                message={message}
                severity={severity}
                onClose={() => setMessage("")}
            />

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ pb: 0 }}>Set Winner Announcement</DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>

                <DialogContent sx={{ pt: 1 }}>
                    <Grid container spacing={2}>
                        {/* Date Picker */}
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <StaticDatePicker
                                    displayStaticWrapperAs="desktop"
                                    value={value}
                                    onChange={(newValue) => setValue(newValue)}
                                />
                                {errors.result_declaration_date && (
                                    <Typography color="error" variant="body2">
                                        {errors.result_declaration_date[0]}
                                    </Typography>
                                )}
                            </LocalizationProvider>
                        </Grid>

                        {/* Time Picker */}
                        <Grid size={{ xs: 12, sm: 6 }} >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <StaticTimePicker
                                    displayStaticWrapperAs="desktop"
                                    value={value}
                                    onChange={(newValue) => setValue(newValue)}
                                />
                                {errors.result_declaration_date && (
                                    <Typography color="error" variant="body2">
                                        {errors.result_declaration_date[0]}
                                    </Typography>
                                )}
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        p: 2,
                    }}
                >
                    {value && (
                        <Typography variant="body2" color="primary">
                            Result Announced At : {formatDateLike(value)}
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleDeclare}
                        disableElevation
                        sx={{ textTransform: "none" }}
                        color="primary"
                    >
                        Declare Now
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default DeclarationDialog;